import { useHistory, useLocation } from "react-router-dom";
import { PATHS } from "../../App";
import { balanceState, walletState } from "../../libs/contexts";

import style from "./Header.module.scss";
import HeaderPc from "./HeaderPc";
import HeaderMobile from "./HeaderMobile";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { useEffect, useState } from "react";
import { queryBalances } from "../../libs/api/trade/query";

import { isWhitelistedCreator } from "../../libs/api/rest";
import { useWallet } from "@terra-money/wallet-provider";

export default function Header() {
    const setBalance = useSetRecoilState(balanceState);
    const history = useHistory();
    const location = useLocation();

    const wallet = useRecoilValue(walletState);
    const { disconnect } = useWallet();

    const [isCreator, setCreator] = useState(false);

    const [menus, setMenus] = useState<{ title: string; path: string }[]>([]);

    useEffect(() => {
        if (wallet) {
            setMenus([
                { title: "My Page", path: PATHS.mypage },
                { title: "Campaigns", path: PATHS.campaigns },
                { title: "Trade", path: PATHS.trade },
                { title: "Governance", path: PATHS.governance },
                { title: "Creator", path: PATHS.producer },
            ]);
        } else {
            setMenus([
                { title: "Campaigns", path: PATHS.campaigns },
                { title: "Trade", path: PATHS.trade },
                { title: "Governance", path: PATHS.governance },
                { title: "Creator", path: PATHS.producer },
            ]);
        }
    }, [wallet]);

    useEffect(() => {
        if (wallet) {
            isWhitelistedCreator(wallet.terraAddress).then((r) => {
                setCreator(r);
            });
        } else {
            setCreator(false);
        }
    }, [wallet]);

    useEffect(() => {
        if (wallet) {
            queryBalances(wallet.terraAddress)
                .then((r) => {
                    setBalance(r);
                })
                .catch((e) => {});
        } else {
            setBalance({
                axlUSDC: "0",
                token: "0",
                Luna: "0",
                vp: "0",
            });
        }
    }, [location, wallet]);

    function connectPressed() {
        history.push(PATHS.connect);
    }

    function disconnectPressed() {
        disconnect();
    }

    return (
        <div className={style.container}>
            <HeaderPc
                menus={menus}
                connect={connectPressed}
                isCreator={isCreator}
                disconnect={disconnectPressed}
            />
            <HeaderMobile
                menus={menus}
                connect={connectPressed}
                isCreator={isCreator}
                disconnect={disconnectPressed}
            />
        </div>
    );
}
